export default {
  'time.hour': '{hour} sa',
  'time.min': '{min} dk',
  'time.sec': '{sec} sn',
  'time.timezone': 'Sistem Zaman Dilimi: {timezone}',
};
